import { Icon } from '@iconify/react';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { pageTitle } from '../../helper';
import Cta from '../Cta';
import Portfolio from '../Portfolio';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import Hero3 from '../Hero/Hero3';
import TestimonialSlider from '../Slider/TestimonialSlider';
import MovingText from '../MovingText';
import LogoList from '../LogoList';



// ...existing imports...
// Helper to convert YouTube URLs to embed format
function getEmbedUrl(url) {
  let videoId = '';
  if (url.includes('youtube.com/watch?v=')) {
    videoId = url.split('v=')[1].split('&')[0];
  } else if (url.includes('youtu.be/')) {
    videoId = url.split('youtu.be/')[1].split('?')[0];
  } else if (url.includes('youtube.com/shorts/')) {
    videoId = url.split('youtube.com/shorts/')[1].split('?')[0];
  }
  if (videoId) {
    return `https://www.youtube.com/embed/${videoId}`;
  }
  return url;
}

// Simple Video Modal component
function VideoModal({ open, onClose, videoUrl }) {
  if (!open) return null;
  return (
    <div
      style={{
        position: 'fixed',
        zIndex: 9999,
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.85)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={onClose}
    >
      <div
        style={{ position: 'relative', width: '90vw', maxWidth: 800, background: 'transparent' }}
        onClick={e => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: -40,
            right: 0,
            background: 'transparent',
            border: 'none',
            color: '#fff',
            fontSize: 32,
            cursor: 'pointer',
          }}
          aria-label="Close"
        >
          &times;
        </button>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
          <iframe
            src={getEmbedUrl(videoUrl)}
            title="Portfolio Video"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              borderRadius: 8,
            }}
          />
        </div>
      </div>
    </div>


);

}


const portfolioData = [
  {
    title: 'School Tour Video',
    subtitle: 'See Details',
    href: 'https://youtu.be/2Lnr61dKPeA',
    src: '/images/portfolioshowcase17.jpg',
    category: 'corporate',
  },

   {
    title: 'Tech Industry Explainer',
    subtitle: 'See Details',
    href: 'https://youtu.be/AxjYHJ87iFU',
    src: '/images/portfolioshowcase18.jpg',
    category: 'vlogs',
  },

   {
    title: 'Nutrition Course | Full Course Post-Production',
    subtitle: 'See Details',
    href: 'https://youtu.be/2eg4Sr_SqhU',
    src: '/images/portfolioshowcase20.jpg',
    category: 'corporate',
  },

  {
    title: 'Showreel 2025',
    subtitle: 'See Details',
    href: 'https://youtu.be/DvTT9TZaGhE',
    src: '/images/portfolioshowcase21.jpg',
    category: 'documentary',
  },
  ///new addition above
  
  {
    title: 'Cycling Vlog',
    subtitle: 'See Details',
    href: 'https://youtu.be/ygBoQ6UNFgs?si=FT2gYjbpxik2E4B3',
    src: '/images/portfolioshowcase2.jpg',
    category: 'vlogs',
  },
  {
    title: 'Hannah Martin',
    subtitle: 'See Details',
    href: 'https://youtu.be/XdTfaS49zbw?si=gYDDUpreFfRYRUvm',
    src: '/images/portfolioshowcase1.jpg',
    category: 'vlogs',
  },

  {
    title: 'Tru North',
    subtitle: 'See Details',
    href: 'https://www.youtube.com/watch?v=5VJXafB5dVk&t=5s',
    src: '/images/portfolioshowcase3.jpg',
    category: 'vlogs',
  },


  {
    title: 'MSU Extension - Documentary',
    subtitle: 'See Details',
    href: 'https://youtu.be/EwDoi7jZ4tM',
    src: '/images/portfolioshowcase4.jpg',
    category: 'documentary',
  },
  {
    title: 'Trump’s China Trade War',
    subtitle: 'See Details',
    href: 'https://www.youtube.com/watch?v=rWTit0VMJp0',
    src: '/images/portfolioshowcase5.jpg',
    category: 'documentary',
  },
  {
    title: 'Cinematic Wedding Teaser',
    subtitle: 'See Details',
    href: 'https://youtu.be/LaChI4Ue7y0',
    src: '/images/portfolioshowcase8.jpg',
    category: 'weddings & events',
  },
  {
    title: 'Sydney & Argie Wedding',
    subtitle: 'See Details',
    href: 'https://youtu.be/0nUm5ffG_Jo',
    src: '/images/portfolioshowcase15.jpg',
    category: 'weddings & events',
  },
  {
    title: 'Faith & Chris Wedding',
    subtitle: 'See Details',
    href: 'https://youtu.be/R_6VylvndWk',
    src: '/images/portfolioshowcase6.jpg',
    category: 'weddings & events',
  },
  {
    title: 'Finexis Event Highlight',
    subtitle: 'See Details',
    href: 'https://youtu.be/TsvbSCpDkx4',
    src: '/images/portfolioshowcase10.jpg',
    category: 'corporate',
  },
  {
    title: 'AI Galaxy',
    subtitle: 'See Details',
    href: 'https://youtu.be/4ajnFxLwHRA',
    src: '/images/portfolioshowcase9.jpg',
    category: 'corporate',
  },
  {
    title: 'Motivational Coach Promo',
    subtitle: 'See Details',
    href: 'https://youtu.be/LXPZMG6uKd4',
    src: '/images/portfolioshowcase16.jpg',
    category: 'corporate',
  },
  {
    title: 'Motivational Course',
    subtitle: 'See Details',
    href: 'https://youtu.be/WeZKxJOVy7o',
    src: '/images/portfolioshowcase11.jpg', 
    category: 'corporate',
  },

  {
    title: 'Corporate Hiring Reel',
    subtitle: 'See Details',
    href: 'https://www.youtube.com/shorts/bcpuf3xI1lk?feature=share',
    src: '/images/portfolioshowcase14.jpg',
    category: 'reels',
  },
{
    title: 'Web Dev Japan',
    subtitle: 'See Details',
    href: 'https://youtube.com/shorts/F0OVltg0wV8?feature=share',
    src: '/images/portfolioshowcase12.jpg',
    category: 'reels',
  },
{
    title: 'Music Event Invitation',
    subtitle: 'See Details',
    href: 'https://youtube.com/shorts/UrVshtgJr1M?feature=share',
    src: '/images/portfolioshowcase13.jpg',
    category: 'reels',

  },
//additional videos 
{
    title: 'AIA Legacy Event - Corporate Event',
    subtitle: 'See Details',
    href: 'https://youtu.be/OzhprX3qJ4o',
    category: 'corporate',

  },
{
    title: 'Tao Nan School - Corporate Documentary',
    subtitle: 'See Details',
    href: 'https://youtu.be/LajOsB3sAvw',
    category: 'documentary',

  },
{
    title: 'Mountain Homestead Vlog',
    subtitle: 'See Details',
    href: ' https://youtu.be/mNPoUtTeVjA',
    category: 'vlogs',

  },

{
    title: 'Bayleigh Craver | Home Wedding Video',
    subtitle: 'See Details',
    href: 'https://youtu.be/aOil1UnP9cg ',
    category: 'weddings & events',

  },

  
{
    title: 'Elanor Carolus | Home Wedding Video',
    subtitle: 'See Details',
    href: 'https://youtu.be/XsonbhOXd58',
    category: 'weddings & events',

  },
{
    title: 'Rachel | Home Wedding Video',
    subtitle: 'See Details',
    href: 'https://youtu.be/fuqZo1xtBGM',
    category: 'weddings & events',

  },

{
    title: 'Zagora Desert Ride 🇲🇦 | Sandstorm Chaos',
    subtitle: 'See Details',
    href: 'https://youtu.be/ledj_prto_M',
    category: 'vlogs',

  },
{
    title: ' Ibiza Vlog',
    subtitle: 'See Details',
    href: 'https://youtu.be/QcsfYiQEHyA',
    category: 'vlogs',

  },

///
];
const categoryMenu = [
   {
    title: 'Vlogs',
    category: 'vlogs',

  },
  
  {
    title: 'Documentary',
    category: 'documentary',
  },
  {
    title: 'Weddings & Events',
    category: 'weddings & events',
  },
  {
    title: 'Corporate',
    category: 'corporate',
  },
{
    title: 'Reels', 
    category: 'reels',
}

];

export default function PortfolioPage() {
  pageTitle('Portfolio');
  const [active, setActive] = useState('all');
  const [itemShow, setItemShow] = useState(7);

  // MOVE THESE INSIDE THE FUNCTION!
  const [modalOpen, setModalOpen] = useState(false);
  const [modalVideo, setModalVideo] = useState('');

  const handleOpenModal = (videoUrl) => {
    setModalVideo(videoUrl);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setModalVideo('');
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // ...rest of your component...

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>


<Hero3
  title="Selected Stories<br />In Motion"
  btnLink="/contact"
  btnText={`Let's talk`}
  socialLinksHeading="Follow Us"
  heroSocialLinks={[
    { name: 'Instagram', links: 'https://www.instagram.com/voxmotionco/' },
    { name: 'LinkedIn', links: 'https://www.linkedin.com/company/vox-motion' },
  ]}
  bgImageUrl="./images/hero_bg_4.jpeg"
/>

      <Spacing lg="145" md="80" />
      <Div className="container">
        <Div className="cs-portfolio_1_heading">
          <SectionHeading title="Some recent work" subtitle="Our Portfolio" />
          <Div className="cs-filter_menu cs-style1">
            <ul className="cs-mp0 cs-center">
              <li className={active === 'all' ? 'active' : ''}>
                <span onClick={() => setActive('all')}>All</span>
              </li>
              {categoryMenu.map((item, index) => (
                <li
                  className={active === item.category ? 'active' : ''}
                  key={index}
                >
                  <span onClick={() => setActive(item.category)}>
                    {item.title}
                  </span>
                </li>
              ))}
            </ul>
          </Div>
        </Div>
        <Spacing lg="90" md="45" />
        <Div className="row">
        {portfolioData
  .filter(item => active === 'all' || item.category === active)
  .slice(0, itemShow)
  .map((item, index) => (
            <Div
              className={`${
                index === 3 || index === 6 ? 'col-lg-8' : 'col-lg-4'
              } ${
                active === 'all'
                  ? ''
                  : !(active === item.category)
                  ? 'd-none'
                  : ''
              }`}
              key={index}
            >
           
           
         <Portfolio
  title={item.title}
  subtitle={item.subtitle}
  href={item.href}
  src={item.src}
  variant="cs-style1 cs-type1"
  isVideo={true}
  onClick={() => handleOpenModal(item.href)}
/>
  

              <Spacing lg="25" md="25" />
            </Div>
          ))}
        </Div>
<VideoModal open={modalOpen} onClose={handleCloseModal} videoUrl={modalVideo} />
        <Div className="text-center">
          {portfolioData.length <= itemShow ? (
            ''
          ) : (
            <>
              <Spacing lg="65" md="40" />
              <span
                className="cs-text_btn"
                onClick={() => setItemShow(itemShow + 3)}
              >
                <span>Load More</span>
                <Icon icon="bi:arrow-right" />
              </span>
            </>
          )}
        </Div>
      </Div>
      <Spacing lg="145" md="80" />
       {/* Start Testimonial Section */}
            <TestimonialSlider />
            {/* End Testimonial Section */}
      
            {/* Start MovingText Section */}
            <Spacing lg="125" md="70" />
            <MovingText text="Our reputed world wide partners" />
            <Spacing lg="105" md="70" />
            {/* End MovingText Section */}
      
            {/* Start LogoList Section */}
            <Div className="container">
              <LogoList />
            </Div>
            <Spacing lg="150" md="80" />
            {/* End LogoList Section */}
      
            {/* Start CTA Section */}
            <Div className="container">
              <Cta
                title="Let’s discuss and make <br />something <i>cool</i> together"
                btnText="Apply For Meeting"
                btnLink="/contact"
                bgSrc="/images/cta_bg_3.jpeg"
              />
            </Div>
            {/* End CTA Section */}
          </>
        );

}
